import { useContext, useEffect } from 'react'
import { ExternalEventEmitter } from '../ExternalEventEmitter'
import { ExternalEvent, AppContext, AppContextType } from '../AppContext'
import useAppContextRef from '../services/useAppContextRef'

export default function useMusePluginStateService() {
    const { dispatch } = useContext(AppContext) as AppContextType

    const { appStateRef } = useAppContextRef()

    useEffect(() => {
        const handler = (externalEvent: ExternalEvent) => {
            if (externalEvent.eventName === 'museplugin') {
                const currIsConnected = appStateRef.current.appState.musePluginState.isConnected

                console.log(
                    `MusePluginStateManager: received plugin state changed event: ` +
                        JSON.stringify(externalEvent.value)
                )
                if (externalEvent.value?.isConnected && !currIsConnected) {
                    // was just now connected.
                    dispatch({
                        type: 'update_app_state',
                        value: { musePluginState: { isValid: true, isConnected: true } },
                    })
                } else if (!externalEvent.value?.isConnected && currIsConnected) {
                    // was just now disconnected.
                    dispatch({
                        type: 'update_app_state',
                        value: { musePluginState: { isValid: true, isConnected: false } },
                    })
                }
            }
        }

        ExternalEventEmitter.on('event', handler)

        return () => {
            ExternalEventEmitter.removeListener('event', handler)
        }
    }, [])
}
